<template>
  <button
    class="btn icon small-icon single-obituary-comment__actions-like"
    type="button"
    :class="{
      liked: isCommentLiked,
      small,
    }"
    :disabled="isLikeLoading"
    :title="texts.like"
    @click.prevent="switchLikingComment"
  >
    <svg
      aria-hidden="true"
      class="icon"
      key="liked-icon"
      v-if="isCommentLiked"
      :class="{
        'icon-xsmall': small,
      }"
      :title="texts.liked"
    >
      <use href="#heart-solid" />
    </svg>
    <svg
      aria-hidden="true"
      class="icon"
      key="unliked-icon"
      v-else-if="!isCommentLiked"
      :class="{
        'icon-xsmall': small,
      }"
      :title="texts.like"
    >
      <use href="#heart" />
    </svg>

    <span v-text="texts.like" />
  </button>
</template>

<script>
  import { toRef } from "vue";
  import { useLikeComment } from "../composables/useLikeComment";

  export default {
    data() {
      return {
        texts: lavendlaObituary.common,
      };
    },

    props: {
      comment: {
        required: true,
        type: Object,
      },
      small: {
        default: false,
        type: Boolean,
      },
    },
    setup(props) {
      const commentRef = toRef(props, "comment");
      const {
        isLikeLoading,
        likedComments,
        isCommentLiked,
        switchLikingComment,
      } = useLikeComment(commentRef);
      return {
        isCommentLiked,
        isLikeLoading,
        likedComments,
        switchLikingComment,
      };
    },
  };
</script>
